module.exports = __webpack_public_path__ + "48df32b28f82776502abcf8ea2d62b50.png";